import { render, staticRenderFns } from "./AppIndexAndPrevalenceComponent.vue?vue&type=template&id=4f843b68&scoped=true&"
import script from "./AppIndexAndPrevalenceComponent.vue?vue&type=script&lang=ts&"
export * from "./AppIndexAndPrevalenceComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AppIndexAndPrevalenceComponent.vue?vue&type=style&index=0&id=4f843b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f843b68",
  null
  
)

export default component.exports